export enum MenuStage {
  INIT = 1,
  SIGNED_IN = 2, // StageC = 4
  // StageD = 8
  // ...
}

export type MenuStageName = keyof typeof MenuStage;

// if entries are added please also revisit ./schema/app-config.schema.json/#/definitions/nav_links
export type AvailableEntries =
  | 'LANDING'
  | 'REGISTER'
  | 'VALIDATE'
  | 'DASHBOARD'
  | 'NEW_ANTRAG'
  | 'ANTRAG_LIST'
  | 'MY_APPLICATIONS'
  | 'DOCUMENTS'
  | 'SETTINGS'
  | 'TUTORIAL'
  | 'VIDEOS'
  | 'FAQ'
  | 'CONTACT'
  | 'IMPRESSUM'
  | 'PRIVACY'
  | '-----'
  | 'DOWNLOAD'
  | 'LOGIN'
  | 'ANDROID_APP'
  | 'IOS_APP'
  | 'BARRIEREFREIHEIT'
  | 'STARTSEITE'
  | 'CUSTOM_NAVLINK'
  | 'START_EINREICHUNG';

export type FooterLinkCategory = 'ABOUT' | 'STORE_ENTRYS' | 'LINKS';

export type NavigationLinkRegistry = { [index in AvailableEntries]: NavigationLink };

export interface NavigationLink {
  a11y?: string;
  readonly allowedStages?: MenuStage;
  category?: FooterLinkCategory;
  dashboardOnlyIcon?: boolean;
  feature: AvailableEntries;
  guard?: () => boolean;
  i18n: string;
  icon?: string;
  init?: () => void;
  ionIcon?: string;
  itemType?: 'icon' | 'menu' | 'link' | 'image';
  mdIcon?: string;
  route: string;
}
